import * as ActionTypes from '../constants/ActionTypes';

const initialState = () => ({
    message: '',
    isShowErrorModal: false
});

export default (state = initialState(), action) => {
    switch (action.type) {
        case ActionTypes.SET_SHOW_API_ERROR_MODAL:
            return {...state, isShowErrorModal: action.payload};
        case ActionTypes.SET_API_ERROR_MODAL_SETTINGS:
            return {...state, isShowErrorModal: action.isShowErrorModal, message: action.message, exceptionCode: action.exceptionCode};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Api.js